import { render, staticRenderFns } from "./ModalChangeAttandance.vue?vue&type=template&id=0bfedb96&scoped=true"
import script from "./ModalChangeAttandance.vue?vue&type=script&lang=js"
export * from "./ModalChangeAttandance.vue?vue&type=script&lang=js"
import style0 from "./ModalChangeAttandance.vue?vue&type=style&index=0&id=0bfedb96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfedb96",
  null
  
)

export default component.exports